'use client'

import { useTranslator } from '@/hooks'
import { mq, presets, rgbAlpha, vw } from '@/styles'
import { memo, useMemo } from 'react'
import styled from 'styled-components'

type ProductInfoSpecification = {
  name: string,
  value: string | number
}

type TypeSectionMoreInfo = {
  data: ProductInfoSpecification[]
}

const getInfo = details => details.map((detail, idx) => {
  return (
    <tr key={idx}>
      <td>{detail.name}</td><td>{detail.value}</td>
    </tr>
  )
})

export const SectionMoreInfo = memo<TypeSectionMoreInfo>(({ data }) => {
  const { t } = useTranslator()
  const Information = useMemo(() => getInfo(data), [data])

  return (
    <section>
      <H2>{t('project.product.product_description.more_info.title')}</H2>
      <Table>
        <tbody>
          {Information}
        </tbody>
      </Table>
    </section>
  )
})


const H2 = styled.h2`
  ${presets.font53}
  color: var(--color-text--darker);
  margin: ${vw(60, 'mobile')} 0 ${vw(20, 'mobile')};

  ${mq.greaterThan('nexus7')} {
    margin: ${vw(80, 'tablet')} 0 ${vw(20, 'tablet')};
  }

  ${mq.greaterThan('tablet')} {
    margin: ${vw(80, 'desktop')} 0 ${vw(20, 'desktop')};
  }

  ${mq.greaterThan('desktop')} {
    margin: 80px 0 20px;
  }
`

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  tr:not(:last-child) {
    border-bottom: 1px solid ${rgbAlpha('--color-text--darker', .2)};
  }

  td {
    ${presets.font15_1}
		color: var(--color-text);
    padding: ${vw(16.5, 'mobile')} 0;
    vertical-align: top;
    width: 50%;

    ${mq.greaterThan('nexus7')} {
      padding: ${vw(16.5, 'tablet')} 0;
    }

    ${mq.greaterThan('tablet')} {
      padding: ${vw(16.5, 'desktop')} 0;
    }

    ${mq.greaterThan('desktop')} {
      padding: 16px 0;
    }

    &:nth-child(odd) {
      color: var(--color-text--darker);
    }
  }
`
